import { Injectable } from '@angular/core';
import { IonToast, ToastController, ToastOptions } from '@ionic/angular';
import { Observable, from, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(private readonly toastCtrl: ToastController) {}

  showNotification(options: ToastOptions): Observable<HTMLIonToastElement> {
    return from(
      this.toastCtrl.create({
        message: options.message,
        duration: 3000,
        animated: true,
        swipeGesture: 'vertical',
        buttons: options.buttons || [
          {
            text: 'OK',
            handler: () => this.toastCtrl.dismiss(),
          },
        ],
      })
    ).pipe(tap((toast) => toast.present()));
  }
}
